import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { useRef } from "react";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a128,
  a129,
  a130,
  a131,
  a132,
  a133,
  a137,
  a138,
  a139,
  a149,
  a18,
  a226,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import style from "./AddBoxNew.module.css";
import { Icon } from "@iconify/react";
import Customertable from "Components/support/customervendor/customer";
import { Box } from "@mui/material";

export default function AddBoxNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CategoryId: "",
    BoxName: "",
    EmptyWeight: "",
    ProductId: "",
    CompanyId: "",
    BranchId: "",
    Description: "",
    Status: "",

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  const [editId, setEditId] = useState("");
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const [selectedPacketMaster, setSelectedPacketMaster] = useState([]);
  const [inputPacketMaster, setInputPacketMaster] = useState("");
  const [PacketMasterData, setPacketMasterData] = useState([]);

  const [searchInput, setSearchInput] = useState("");

  const handleAddVendor = () => {
    if (
      inputPacketMaster &&
      !selectedPacketMaster.includes(inputPacketMaster)
    ) {
      setSelectedPacketMaster([...selectedPacketMaster, inputPacketMaster]);
      setInputPacketMaster("");
    }
  };

  const handlenew = () => {
    setActive("AddNew");
  };

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);

  const handleList = () => {
    // Custom logic for the List button
    console.log("List button clicked");
    setActive("List");
  };

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  function getAllPacket() {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a226, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setPacketMasterData(data));
  }

  useEffect(() => {
    getAllPacket();
  }, []);

  const handleRemoveVendor = (index) => {
    const newVendors = selectedPacketMaster.filter((_, i) => i !== index);
    setSelectedPacketMaster(newVendors);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a137, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log('allCategories', allCategories);
  
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Departments First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Roles First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Category First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategoriesList();
  }, []);

  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllProductsList();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };

  const trasformData = selectedPacketMaster
    .map((item) => item.split("-")[0])
    .join(",");
  // const trasformData = selectedPacketMaster.join(',');

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = editId
      ? {
          Id: editId,
          ClientCode: clientCode,
          CategoryId: newCategory.CategoryId,
          BoxName: newCategory.BoxName,
          EmptyWeight: newCategory.EmptyWeight,
          ProductId: newCategory.ProductId,
          CompanyId: newCategory.CompanyId,
          BranchId: newCategory.BranchId,
          Description: newCategory.Description,
          Status: newCategory.Status,
          EmployeeCode: employeeCode,
          PacketIds: trasformData,
          ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
        }
      : {
          ClientCode: clientCode,
          CategoryId: newCategory.CategoryId,
          BoxName: newCategory.BoxName,
          EmptyWeight: newCategory.EmptyWeight,
          ProductId: newCategory.ProductId,
          CompanyId: newCategory.CompanyId,
          BranchId: newCategory.BranchId,
          Description: newCategory.Description,
          Status: newCategory.Status,
          EmployeeCode: employeeCode,
          PacketIds: trasformData,
          ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
        };
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a139 : a138,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        CategoryId: "",
        BoxName: "",
        EmptyWeight: "",
        ProductId: "",
        CompanyId: "",
        BranchId: "",
        Description: "",
        Status: "",
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.Message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("Box Added Successfully");
        setShowError(true);
        setEditId("");
        getAllPacket();
      }
      setLoading(false);
      setSelectedPacketMaster([]);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    setEditId(data.Id);
    setNewCategory({ ...data, OldEntry: true });
    if (data.PacketIds && data.PacketIds.split(",").length > 0) {
      setSelectedPacketMaster(data.PacketIds.split(","));
    }

    setActive("AddNew");
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "CategoryName", label: "Category Name", type: "read", priority: 1 },

    { key: "ProductName", label: "Product Name", type: "read", priority: 3 },
    { key: "BoxName", label: "Box Name", type: "read", priority: 4 },
    { key: "Packets", label: "Packets", type: "read", priority: 5 },
    { key: "EmptyWeight", label: "EmptyWeight", type: "read", priority: 6 },

    {
      key: "Description",
      label: "Description",
      type: "read",
      priority: 7,
    },
    { key: "Status", label: "Status", type: "read", priority: 8 },
   
  ];

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
     
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Box"}
          companyName={"Loyalstring"}
          module={"Product Masters"}
          page={"Box"}
        />

        <div style={{ padding: "16px" }}>
          {active == "List" ? (
            <>
               <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>
              <Customertable
                columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                title={"All Vendors"}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
              />
            </>
          ) : (
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <form style={{ width: "100%" }} onSubmit={addNewCategory}>
                    <div
                     style={{
                          gridTemplateColumns: "repeat(4,2fr)",
                          columnGap: "30px",
                          margin: "0px 0px",
                          padding: "var(--Space-0, 0px) 24px",
                        }}
                      // className="adminCategoryAddCategoryInnerBox"
                    >
                      <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                                                style={{
                                                  gridTemplateColumns: "repeat(4,1fr)",
                                                  columnGap: "40px",
                                                  margin: "15px 0px",
                                                }}
                                                className="adminCategoryAddCategoryInnerBox"
                                              >
                      <label>
                        Company <sup>*</sup>
                      </label>
                      <select
                        ref={inputRef1}
                        onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                        name="CompanyId"
                        value={newCategory.CompanyId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                      >
                        <option value={""}>Select an option</option>;
                        {allCompaniesList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.CompName}</option>;
                            </>
                          );
                        })}
                      </select>{" "}
                      <label>
                        Branch <sup>*</sup>{" "}
                      </label>
                      <select
                        ref={inputRef2}
                        onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                        name="BranchId"
                        value={newCategory.BranchId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                      >
                        <option value={""}>Select an option</option>;
                        {allBranchesList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.BranchName}</option>;
                            </>
                          );
                        })}
                      </select>{" "}
                      <label>
                        Category <sup>*</sup>
                      </label>
                      <select
                        ref={inputRef3}
                        onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                        name="CategoryId"
                        value={newCategory.CategoryId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                      >
                        <option value={""}>Select an option</option>
                        {allCategoriesList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.CategoryName}</option>;
                            </>
                          );
                        })}
                      </select>{" "}
                      <label>
                        Product<sup>*</sup>
                      </label>
                      <select
                        ref={inputRef4}
                        onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        name="ProductId"
                        value={newCategory.ProductId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                      >
                        <option value={""}>Select an option</option>
                        {allProductsList
                          .filter((pro) => {
                            const matchesCategory =
                              newCategory.CategoryId === 0 ||
                              newCategory.CategoryId === "" ||
                              newCategory.CategoryId === null
                                ? true
                                : pro.CategoryId ===
                                  parseInt(newCategory.CategoryId);
                            return matchesCategory;
                          })
                          .map((x) => {
                            return (
                              <option value={x.Id}>{x.ProductName}</option>
                            );
                          })}
                      </select>{" "}
                      <label>
                        Box Name<sup>*</sup>
                      </label>
                      <input
                        ref={inputRef5}
                        onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        name="BoxName"
                        value={newCategory.BoxName}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        style={{border: '1px solid #ddd'}}
                      />
                      <label>
                        Empty Weight<sup>*</sup>
                      </label>
                      <input
                        ref={inputRef6}
                        onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        name="EmptyWeight"
                        value={newCategory.EmptyWeight}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        style={{border: '1px solid #ddd'}}
                      />
                      <label>Description</label>
                      <input
                        ref={inputRef7}
                        onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        name="Description"
                        value={newCategory.Description}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{border: '1px solid #ddd'}}
                      />
                      <label htmlFor="Status">
                        Status <sup>*</sup>
                      </label>
                      <select
                        ref={inputRef8}
                        onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        name="Status"
                        required="required"
                        value={newCategory.Status}
                        onChange={handleNewCategoryChange}
                        style={{border: '1px solid #ddd'}}
                      >
                        <option value={""}>Select Status</option>
                        <option value={"Active"}>Active</option>
                        <option value={"InActive"}>InActive</option>
                      </select>
                      {/*<div className="adminSkuAddSkuInnerItemsBox">*/}
                      <label htmlFor="netWt" style={{ margin: "10px 0px" }}>
                        Select Packet Master
                      </label>
                      <select
                        ref={inputRef9}
                        onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        type="number"
                        // required="required"
                        // name="VendorId"
                        value={inputPacketMaster}
                        onChange={(e) => setInputPacketMaster(e.target.value)}
                        style={{border: '1px solid #ddd'}}
                      >
                        <option value={0}>Select Packet</option>
                        {PacketMasterData.filter(
                          (item) => item.BoxName == "" || item.BoxName == null
                        ).map((x) => (
                          <option value={`${x.Id}-${x.PacketName}`}>
                            {`${x.PacketName} - ${x.Id}`}
                          </option>
                        ))}
                      </select>
                      <button
                        // style={{
                        //   marginBottom: "25px",
                        //   margin: "0px 20px",
                        //   width: "180px",
                        // }}
                        // type="button"
                        onClick={handleAddVendor}
                        className={style["packet-btn"]}
                      >
                        Add Packet
                      </button>
                      {/*</div>*/}
                      <div
                        style={{ gridColumn: "span 2" }}
                        className="adminSkuAddSkuInnerItemsBox"
                        id="adminSkuAddSkuSelectVendor"
                      >
                        <label htmlFor="netWt">
                          Total {selectedPacketMaster.length} Packets
                        </label>
                        <div
                          style={{
                            display: "flex",
                            overflowX: "auto",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          {selectedPacketMaster?.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "5px 10px",
                                borderRadius: "5px",
                                backgroundColor: "#f0f0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "auto",
                              }}
                            >
                              <span style={{ whiteSpace: "nowrap" }}>
                                {item}
                              </span>
                              <button
                                type="button"
                                onClick={() => handleRemoveVendor(index)}
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  margin: "0px",
                                  padding: "0px",
                                  color: "red",
                                  border: "none",
                                  background: "transparent",
                                }}
                              >
                                &#10005; {/* Unicode cross symbol */}
                              </button>
                            </div>
                          ))}
                          
                        </div>
                      </div>
                      </div>
                      </Box>
                    </div>
                    {!loading ? (
                      <div className={style["btn-container"]}>
                        <button className={style.buttons} type="submit">
                          <Icon
                            icon="ic:baseline-check"
                            width="24"
                            height="24"
                          />{" "}
                          Submit
                        </button>
                        <button
                          className={style.buttons}
                          style={{
                            backgroundColor: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                          }}
                          type="button"
                          onClick={handleResetField}
                        >
                          <Icon
                            style={{ color: "#0077d4" }}
                            icon="ix:reset"
                            width="24"
                            height="24"
                          />
                          Reset
                        </button>
                        <button
                          className={style.buttons}
                          type="button"
                          onClick={handleList}
                        >
                          <Icon
                            icon="fluent:list-rtl-16-filled"
                            width="24"
                            height="24"
                          />
                          List
                        </button>
                      </div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
